'use client';

import { Box, Button, Flex, ModalNext, Stack, Text } from '@instamenu/ui-system-next';
import { themeVars } from '@instamenu/ui-vanilla-extract';
import { badge, actions, description } from './low-tip-modal.css';

type LowTipModalProps = {
  opened: boolean;
  onAddTip: () => void;
  onContinueWithoutTip: () => void;
  onClose: () => void;
};

export function LowTipModal({ opened, onAddTip, onContinueWithoutTip, onClose }: LowTipModalProps) {
  return (
    <ModalNext
      opened={opened}
      onRequestClose={onClose}
      withCloseButton={false}
      containerStyle={{ padding: themeVars.pad[12] }}
    >
      <Box>
        <Stack style={{ gap: themeVars.pad[16] }}>
          <Box className={badge}>Delivery reminder</Box>
          <Stack style={{ gap: 6 }}>
            <Text css={{ fontWeight: 500 }}>
              Orders with low tips may take longer to be delivered. Do you want to continue?
            </Text>
            <Text variant="body1" className={description}>
              Orders with lower tips may take longer to be accepted, which can result in slower
              delivery.
            </Text>
          </Stack>
          <Flex className={actions}>
            <Button onClick={onAddTip}>Update tip</Button>
            <Button variant="secondary" onClick={onContinueWithoutTip}>
              Continue with current tip
            </Button>
          </Flex>
        </Stack>
      </Box>
    </ModalNext>
  );
}
